import { css } from '@emotion/css';

export const defaultCoverImageStyles = css`
  width: 26.6rem;
  height: 20rem;
  border-radius: 1.2rem;
`;
